// Author: Charles Nana Kwakye
// needed for the mobile version

//cick event listener on mobile navigation button to show mobile navigation links
$('.mob-nav').click(() => {
    // add 'open' classes to show mobile navigation
    $('.mob-links').addClass('open');
});

// Click event listener on document
$(document).click(function () {
    // checking wheather the window width is smaller than 992px
    if ($(window).width() < 992) {
        // Verifying wheather the click wasn't made on mobile-nav button or the navigation itself to enable auto close when user clicks on document outside the mentioned elements
        if (!$(event.target).closest('.mob-links,.mob-nav').length) {
            // check wheather the mobile-nav pane is open
            if ($('.mob-links').hasClass('open')) {
                // Disable click events default functionality
                event.preventDefault();
                // remove class open from element mobile-links
                $('.mob-links').removeClass('open');
            }
        }
    }
});
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
});
